import {
    FastLineRenderableSeries,
    IOverviewOptions,
    IRenderableSeries,
    ModifierMouseArgs,
    OverviewRangeSelectionModifier,
    Thickness,
} from "scichart";
import { GetChartTheme } from "./ChartConfiguration";

const theme = GetChartTheme();

// Overview range-selection modifier that resets the selection to the full
// data extent (i.e. zooms the parent chart out on X) when the overview is
// double-clicked. The base modifierDoubleClick is a no-op.
class DoubleClickResetOverviewModifier extends OverviewRangeSelectionModifier {
    modifierDoubleClick(args: ModifierMouseArgs) {
        super.modifierDoubleClick(args);
        // The overview X axis is auto-ranged to the full data extent.
        const xAxis = this.parentSurface?.getXAxisById(this.xAxisId);
        if (!xAxis) {
            return;
        }
        const fullRange = xAxis.visibleRange;
        this.selectedArea = fullRange;            // move the overview selection box
        this.onSelectedAreaChanged?.(fullRange);  // drive the main chart's X range
    }
}

// options used for current example
export const overviewOptions: IOverviewOptions = {
    theme: theme,
    disableAspect: true,
    padding: Thickness.fromNumber(5),
   
    transformRenderableSeries: (renderableSeries: IRenderableSeries) => {
   
        const copiedSeries = new FastLineRenderableSeries(renderableSeries.parentSurface.webAssemblyContext2D, {
            dataSeries: renderableSeries.dataSeries,
            stroke: "rgba(50, 53, 67, 0.65)",
        });

        return copiedSeries;
    },
};

// Same as overviewOptions, but double-clicking the overview resets the X range.
// A factory (not a constant) so each chart mount gets its own modifier instance
// rather than sharing one across surfaces.
export const getResettableOverviewOptions = (): IOverviewOptions => ({
    ...overviewOptions,
    customRangeSelectionModifier: new DoubleClickResetOverviewModifier(),
});

// options used for current example
export const endpointReportOverviewOptions: IOverviewOptions = {
  theme: theme,
  disableAspect: true,
  padding: new Thickness(0, 5, 0, 5),

};